// extracted by mini-css-extract-plugin
module.exports = {"activateContainer":"styles_activateContainer__22HPZ","activateHeader":"styles_activateHeader__C3SIM","formMessages":"styles_formMessages__38pWC"};